// extracted by mini-css-extract-plugin
module.exports = {"root":"BookingTimeInfo_root__2xa3U","bookingInfo":"BookingTimeInfo_bookingInfo__18i-p","dateSection":"BookingTimeInfo_dateSection__TIsd4"};